import { render, staticRenderFns } from "./BusinessIncomeTable.vue?vue&type=template&id=74409e1a&scoped=true"
import script from "./BusinessIncomeTable.vue?vue&type=script&lang=js"
export * from "./BusinessIncomeTable.vue?vue&type=script&lang=js"
import style0 from "./BusinessIncomeTable.vue?vue&type=style&index=0&id=74409e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74409e1a",
  null
  
)

export default component.exports